import React, { useEffect } from "react";
import {
  // Toast,
  // ToastContainer,
  Card,
  Row,
  Col
} from "react-bootstrap";

import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import { getAdminDashboardCounts } from "./dashboardSlice";

// import {
//   CheckmarkBadge04Icon,
// } from "../../assets/icons";

export default function List() {
  // const [showSnackbar, setShowSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarVariant, setSnackbarVariant] = useState("toast-success");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const { adminDashboardCounts } = useSelector((state) => state.dashboard);
  // const { total_products, total_customers, total_orders, total_categories } = adminDashboardCounts;

  const token = localStorage.getItem('admin-auth-token');

  useEffect(() => {
    const fetchAdminDashboardCounts = async () => {
      setLoading(true);
      try {
        if (token) {
          await dispatch(getAdminDashboardCounts());
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchAdminDashboardCounts();
  }, [dispatch, token, setLoading]);


  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="text-muted text-primary-hover"
    >
      {children}
    </Link>
  ));

  CustomToggle.displayName = "CustomToggle";

  return (
    <>
      {/* <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{snackbarMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer> */}

      <Container fluid className="px-0">
        <h5 className="mb-3">Dashboard Counts</h5>
        <Row className="g-3">
          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Organizations</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.organizations || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Organizations"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/organizations");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Templates</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.templates || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Templates"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/templates");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Business Types</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.business_types || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Business Types"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/business-types");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Organization Types</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.organization_types || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Organization Types"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/organization-types");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Legal Firms</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.legal_firms || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Legal Firms"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/legal-firms");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Countries</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.countries || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Countries"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/countries");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">States</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.states || '-'}
                </Card.Text>
              <CommonButton
                title={"View All States"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/states");
                }}
              />
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title className="mb-3">Cities</Card.Title>
                <Card.Text className="fw-semibold fs-3 mb-3">
                  {adminDashboardCounts?.cities || '-'}
                </Card.Text>
              <CommonButton
                title={"View All Cities"}
                type="submit"
                className="btn-primary"
                onClick={() => {
                  navigate("/cities");
                }}
              />
              </Card.Body>
            </Card>
          </Col>
          
      </Row>
      </Container>
    </>
  );
}
